import React from 'react';
import { FileText, CalendarCheck, Truck, ClipboardCheck } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    icon: FileText,
    title: '1. Get Your Free Quote',
    description: 'Fill out our short form or call us. We provide a transparent, all-inclusive boat transport quote with zero hidden fees.'
  }, {
    icon: CalendarCheck,
    title: '2. Schedule Pickup',
    description: 'Once approved, our experienced boat haulers schedule a convenient pickup time. No upfront payment required.'
  }, {
    icon: Truck,
    title: '3. We Safely Haul Your Boat',
    description: 'Our licensed boat movers handle the nationwide boat transport process door-to-door, keeping you updated.'
  }, {
    icon: ClipboardCheck,
    title: '4. Delivered & Inspected',
    description: 'Your vessel arrives safely at its destination. We perform a final inspection together before you sign off.'
  }];
  return <section className="py-20 bg-slate-50" data-id="element-158">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-159">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-160">
          <h2 className="text-3xl md:text-4xl font-black text-brand-navy mb-4" data-id="element-161">
            How Boat Transport Works
          </h2>
          <p className="text-lg text-slate-600" data-id="element-162">
            Shipping a boat doesn't have to be stressful. Our streamlined
            process ensures your vessel is moved safely and efficiently.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center" data-id="element-163">
          {/* Photo Column */}
          <div className="lg:col-span-5" data-id="element-164">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl" data-id="element-165">
              <img src="https://cdn.magicpatterns.com/uploads/pqZo2XRZMhWBCv7CvXr14X/Boat_Transport.png" alt="A boat being hauled on a trailer by a semi-truck on the highway" className="w-full h-[400px] lg:h-[600px] object-cover" data-id="element-166" />
              <div className="absolute inset-0 bg-gradient-to-t from-brand-navy/60 to-transparent" data-id="element-167"></div>
              <div className="absolute bottom-6 left-6 right-6 text-white" data-id="element-168">
                <p className="font-bold text-xl mb-1" data-id="element-169">Safety First</p>
                <p className="text-sm text-slate-200" data-id="element-170">
                  Every vessel is professionally secured and inspected before
                  transit.
                </p>
              </div>
            </div>
          </div>

          {/* Steps Column */}
          <div className="lg:col-span-7" data-id="element-171">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 relative" data-id="element-172">
              {steps.map((step, index) => <div key={index} className="relative z-10 flex flex-col items-start bg-white p-6 rounded-xl shadow-sm border border-slate-100" data-id="element-173">
                  <div className="w-16 h-16 bg-brand-navy/5 rounded-full flex items-center justify-center mb-4" data-id="element-174">
                    <step.icon className="w-8 h-8 text-brand-red" data-id="element-175" />
                  </div>
                  <h3 className="text-xl font-bold text-brand-navy mb-2" data-id="element-176">
                    {step.title}
                  </h3>
                  <p className="text-slate-600 text-sm leading-relaxed" data-id="element-177">
                    {step.description}
                  </p>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}